module.exports = __webpack_public_path__ + "img/inquire_payroll_wx.33288c0b.jpg";